module.exports = __webpack_public_path__ + "img/sgqr.60d6069b.svg";